import React from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

const UserInfoRow = ({
  label,
  value,
  labelClass = "text-blue",
  valueClass = "text-darkGrey",
}) => (
  <div className="flex justify-between items-center">
    <p className={`${labelClass} font-semibold medium`}>{label}</p>
    <p className={`${valueClass} font-semibold medium`}>{value}</p>
  </div>
);

const UserDetails = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { user } = location.state || {}; // Get user data from navigation state

  return (
    <div className="files-main py-[43px] flex flex-col gap-[35px]">
      <div className="top flex items-center gap-[14px]">
        <img
          src="../../assets/images/dashboard/arrow-left-blue.png"
          alt="Back"
          className="drop-shadow-xl cursor-pointer"
          onClick={() => navigate("/users")}
        />
        <h5 className="text-blue font-bold">User details</h5>
      </div>

      <div className="details-bottom flex items-start gap-[20px] h-100 min-h-[60vh] max-sm:flex-col max-sm:gap-[30px]">
        <div className="left-div details-back max-w-[30%] max-sm:max-w-[100%] max-sm:min-h-fit min-h-[60vh] h-full w-full rounded-[20px] px-[15px] pt-[20px] pb-[40px] flex flex-col gap-[31px]">
          <div className="avatar max-w-[83px] h-[83px] w-full cursor-pointer rounded-[50px] flex justify-center items-center py-[3px] px-[16px] bg-[var(--Primary-color,#143A62)] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)] backdrop-blur-[72.719px]">
            <h4 className="uppercase text-white font-semibold">
            {user?.username[0].toUpperCase()}
            </h4>
          </div>

          {/*User Details  */}
          <div className="user-content flex flex-col gap-[24px]">
            <div className="flex flex-col gap-[10px]">
              {/* <UserInfoRow label="Name" value="Tim doe" /> */}
              <UserInfoRow label="Name" value={user?.username || "N/A"} />
              <UserInfoRow label="Email" value={user?.email || "N/A"} />
              {/* <UserInfoRow label="Email" value="john12@gmail.com" /> */}
            </div>

            <hr className="w-full h-[1px] bg-[#E2E2E2]" />

            <div className="flex flex-col gap-[10px]">
              <UserInfoRow
                label="Date joined"
                value={
                  user?.createdAt
                    ? new Date(user.createdAt).toLocaleDateString()
                    : "N/A"
                }
              />
              <UserInfoRow label="File uploads" value={user?.totalUploads || "N/A"} />

              {/* <UserInfoRow label="Date joined" value="10/15/2024" /> */}
              {/* <UserInfoRow label="File uploads" value="200" /> */}
            </div>

            <hr className="w-full h-[1px] bg-[#E2E2E2]" />

            <div className="flex flex-col gap-[10px]">
              <p className="text-blue font-medium small">Plan taken</p>
              <UserInfoRow label="Plan taken" value={user?.plan || "N/A"} />
              {/* <UserInfoRow
                label="Premium"
                value="$20.0"
                labelClass="text-blue"
                valueClass="light-blue-color"
              /> */}
            </div>
          </div>
        </div>

        <div className="right-switcher max-w-[70%] w-full max-sm:max-w-[100%] min-h-[60vh] h-full flex flex-col gap-[20px]">
          <div className="switcher-top-bar  sm-s:flex-col sm-s:justify-center flex justify-between gap-[20px] items-center w-100">
            <div className="w-full max-w-full flex gap-[12px] sm-s:justify-center">
              <NavLink
                to="chat-history"
                className={({ isActive }) =>
                  `flex justify-center items-center rounded-[28px] cursor-pointer shadow-lg backdrop-blur-2xl p-[8px] max-w-[168px] w-full h-[45px] ${
                    isActive
                      ? "bg-darkblue text-white"
                      : "bg-[#DFE2E6] text-blue"
                  }`
                }
              >
                <p className="font-medium medium">Chat history</p>
              </NavLink>

              <NavLink
                to="files-upload"
                className={({ isActive }) =>
                  `flex justify-center items-center rounded-[28px] cursor-pointer shadow-lg backdrop-blur-2xl p-[8px] max-w-[168px] w-full h-[45px] ${
                    isActive
                      ? "bg-darkblue text-white"
                      : "bg-[#DFE2E6] text-blue"
                  }`
                }
              >
                <p className="font-medium medium">Files upload</p>
              </NavLink>
            </div>
            <div className="flex justify-center gap-[10px] items-center rounded-[28px] bg-[#F2D2D2] cursor-pointer p-[8px] shadow-lg backdrop-blur-2xl max-w-[168px] w-full h-[45px]">
              <p className="text-[#EA1912] font-medium medium">Block user</p>
              <Icon
                icon="ic:round-block"
                color="#EA1912"
                width={18}
                height={18}
              />
            </div>
          </div>
          <div className="switcher-bottom details-back rounded-[20px] min-h-[53vh] h-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
